import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useState } from 'react';
// Define the initial state of the context
const initialValue = {
    onSeeAllClick: () => { },
};
// Create the context
export const SourSearchContext = createContext(initialValue);
// Create a provider component
export const SourSearchProvider = ({ children, onSeeAllClick }) => {
    const [state] = useState({
        // Initialize your state properties here
        onSeeAllClick,
    });
    return _jsx(SourSearchContext.Provider, { value: state, children: children });
};
//# sourceMappingURL=SourSearchContext.js.map